import type { StoreApi, UseBoundStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface IntroWidgetDismissalState {
  dismissed: boolean;
  dismiss: () => void;
}

export const useIntroWidgetDismissalStore: UseBoundStore<StoreApi<IntroWidgetDismissalState>> =
  createTrackedStore<IntroWidgetDismissalState>('useIntroWidgetDismissalStore')(
    persist(
      (set) => ({
        dismissed: false,
        dismiss: (): void => {
          set({ dismissed: true });
        },
      }),
      {
        name: 'morfi-intro-widget-dismissed',
        // Explicit JSON wrapper around `localStorage`. The default behaviour
        // is functionally identical, but Zustand v5's default reads
        // `window.localStorage` and that reference path can return a stub
        // in some test envs (jsdom + Vitest module init order) that lacks
        // `setItem`. Naming `localStorage` directly avoids the indirection.
        storage: createJSONStorage(() => localStorage),
      },
    ),
  );
